/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 14:36:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 18:49:14
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/ReviewCard/Content/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React, { useContext } from 'react';
import { Button, TextArea } from 'src/components/Antd';
import {
  ColorLinedButton,
  LinedButton,
} from 'src/components/Antd/Button/Button';
import Link from 'src/components/Link/GreenLink';
import Image, { Type } from 'src/components/Upload/ImageDisplay';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import { EnumReviewType } from 'src/pages/ProductReview/common';
import { salesChannelType } from 'src/tools/constant';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { ReplyContext } from '../index';
import Channel from './Channels';
import css from './css.module.less';
//import { get } from 'lodash';
import CountWords from '@/src/components/CountWords/CountWords';
import {
  i18nGet,
  handleOnGetStoreTimezoneUTC,
  handleOnFormatStoreTimeAndDateWithTimezone,
} from '@/src/tools/tools';
import VisibilityToggle from '@/src/components/VisibilityToggle';
import { modal } from '@/src/utils/Modal';
import { useI18n } from 'src/hooks/useRouterChange';
import { UPLOAD_VIDEO } from 'src/tools/constant';
import { last } from 'lodash';
import { maskConfigFullName } from '@/src/tools/mask';
//  {
//     createdDate = '30 Apr 2021 14:26:37 (GMT +11)',
//     order = {},
//     content = 'aaa',
//     fromSalesChannel,
//     customerName = 'luke',
//     staffUuid = 'asd',
//     medias = [
//       {
//         url:
//           'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png',
//       },
//       {
//         url:
//           'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png',
//       },
//       {
//         url:
//           'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png',
//       },
//       {
//         url:
//           'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png',
//       },
//       {
//         url:
//           'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png',
//       },
//       {
//         url:
//           'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png',
//       },
//     ],
//     replies = [
//       {
//         createdDate: '30 Apr 2021 14:26:37 (GMT +11)',
//         staffUuid: 'Lukee hahah',
//         reply: '牛逼牛逼',
//       },
//     ],
//     productReviewSalesChannels = [
//       {
//         name: 1,
//         uuid: '1',
//         locales: [{ isPrimary: true, top: true, publish: true }],
//       },
//       {
//         name: 2,
//         uuid: '2',
//         locales: [
//           { isPrimary: true, top: true, publish: true, locale: 'English' },
//           { isPrimary: false, top: false, publish: true, locale: '中文' },
//           { isPrimary: false, top: true, publish: false, locale: 'Korea' },
//         ],
//       },
//     ],
//     //status,
//   }

const Content = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();
  const { replyOpen, setReplyOpen } = useContext(ReplyContext);
  const [isVisible, setIsVisible] = React.useState(false);

  const { data, func } = props;

  const {
    createdDate,

    content,
    fromSalesChannel,
    customerName,
    staffName,
    medias = [],
    replies = [],
    productReviewSalesChannels = [],
    reviewUuid,
    isFake,
    status,
    customerUuid,
    customerDatabaseUuid,
    orderNo,
    orderUuid,
  } = data || {};

  const nonChannelsArr = [EnumReviewType.Archive, EnumReviewType.Spam];
  const hideChannels = nonChannelsArr.includes(status);

  const { onReplyDelete, onReplyAdd, onPubTopChange } = func;

  const handleOnPubTopChange = (body) => {
    const re = { ...(body || {}), reviewUuid };
    if (onPubTopChange) onPubTopChange(re);
  };

  const handleOnCloseReply = () => {
    if (setReplyOpen) {
      setReplyOpen(false);
    }
  };

  const handleOnReplySubmit = (reply) => {
    if (onReplyAdd) {
      onReplyAdd({ reply: { reply, reviewUuid: reviewUuid } });
    }
    handleOnCloseReply();
  };
  const _order = React.useMemo(() => {
    // const uuid = get(order, 'uuid');
    if (orderUuid) {
      // when order finished
      return (
        <span>
          {getI18n('reviews.productreview.orderNo')}{' '}
          <Link to={`/order/${orderUuid}`}>{orderNo}</Link>
        </span>
      );
      //const {}
    }
    return null;
  }, [orderNo, orderUuid]);

  const _medias = React.useMemo(() => {
    if (medias.length > 0) {
      return (
        <Row
          containerClassName={css.imageRowContainer}
          elements={[
            {
              child: (
                <div className={css.imagesRowContainer}>
                  {medias.map((m, index, self) => {
                    const { url } = m;
                    const type: string = last((url || '').split('.'));
                    const isVideo = UPLOAD_VIDEO.includes(type);
                    return (
                      <div
                        key={index}
                        className={css.imgContainer}
                        {...(index === self.length - 1
                          ? {
                              style: { marginRight: 0 },
                            }
                          : {})}>
                        {!isVideo ? (
                          <Image
                            type={Type.Fill}
                            imageUrl={url}
                            hideAction
                            height={160}
                          />
                        ) : (
                          <video
                            // type={Type.Fill}
                            controls
                            height={160}
                            width={160}>
                            <source src={url} type={`video/${type}`}></source>
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>
                    );
                  })}
                </div>
              ),
            },
          ]}
        />
      );
    }
    return null;
  }, [medias]);

  const _channels = React.useMemo(() => {
    return !hideChannels ? (
      <SectionContent className={css.channelsContainer}>
        {productReviewSalesChannels.map((i, index) => {
          return <Channel onChange={handleOnPubTopChange} key={index} {...i} />;
        })}
      </SectionContent>
    ) : null;
  }, [hideChannels, productReviewSalesChannels]);

  const _editedBy = React.useMemo(() => {
    const left = (
      <ItemWrapper
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>
              {getI18n(
                'reviews.productreview.productReviewDetail_AddReview_genaral_Username_title',
              )}
            </span>
            <VisibilityToggle defaultVisible={false} onToggle={setIsVisible} />
          </div>
        }>
        {isFake ? (
          isVisible ? (
            customerName
          ) : (
            maskConfigFullName(customerName)
          )
        ) : (
          <Link
            to={`/customerDatabase/customerDetail/${customerDatabaseUuid}/${customerUuid}`}>
            {customerName}
          </Link>
        )}
      </ItemWrapper>
    );
    if (fromSalesChannel && !isFake) {
      const { channelType, name } = fromSalesChannel;
      //when user finish
      const right = (
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_ReviewCard_content_review_from',
          )}>
          <div>
            {salesChannelType[channelType]}: {name}
          </div>
        </ItemWrapper>
      );
      return { left, right };
    } else {
      const right = (
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_ReviewCard_content_review_added',
          )}>
          <div>{staffName || ''}</div>
        </ItemWrapper>
      );
      return { left, right };
    }
  }, [
    staffName,
    fromSalesChannel,
    customerName,
    isFake,
    isVisible,
    customerUuid,
    customerDatabaseUuid,
  ]);

  const _replyDisplay = React.useMemo(() => {
    const hasExistingReply = replies.length;
    if (hasExistingReply) {
      return replies.map((r) => {
        const { modifiedDate, staffUuid, reply, uuid } = r;
        const modified = handleOnFormatStoreTimeAndDateWithTimezone(
          modifiedDate || null,
        );

        return (
          <Reply
            onReplyDelete={onReplyDelete}
            key={uuid}
            uuid={uuid}
            reply={reply}
            createdDate={`${modified} (UTC ${timezoneInUTC})`}
            staffUuid={staffUuid}
            timezoneInUTC={timezoneInUTC}
          />
        );
      });
    } else {
      if (replyOpen) {
        return (
          <EditingReply
            onSubmit={handleOnReplySubmit}
            onCancel={handleOnCloseReply}
          />
        );
      }
      return null;
    }
  }, [replies, replyOpen]);
  const created = handleOnFormatStoreTimeAndDateWithTimezone(
    createdDate || null,
  );

  return (
    <div className={css.wrapper}>
      <SectionContent hasBottomBorder className={css.contentSection}>
        <Row
          containerClassName={css.rowContainer}
          elements={[
            {
              child: (
                <div>
                  {created} {`(UTC ${timezoneInUTC})`}
                </div>
              ),
            },
            { child: _order },
          ]}
        />
        <Row
          containerClassName={css.rowContainer}
          elements={[
            { child: <div className={css.contentContainer}>{content}</div> },
          ]}
        />
        {_medias}
        <Row
          elements={[{ child: _editedBy.left }, { child: _editedBy.right }]}
        />
      </SectionContent>
      {_replyDisplay}
      {_channels}
    </div>
  );
};

export default Content;

const Reply = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsReview,
        operation: EnumOperation.delete_review,
      }),
    ],
  });

  const { createdDate, staffName, reply, onReplyDelete, uuid } = props;
  const handleOnDelete = (uuid) => {
    if (onReplyDelete) onReplyDelete({ uuid });
  };
  return (
    <SectionContent hasBottomBorder>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                containerClassName={css.itemWrapperContainerClassName}
                title={getI18n(
                  'reviews.productreview.productReviewDetail_ReviewCard_content_replyToReview',
                )}>
                {createdDate}
              </ItemWrapper>
            ),
          },
          {
            child: (
              <div className={css.replyDeleteContainer}>
                <ItemWrapper
                  containerClassName={css.deleteItemWrapperContainerClassName}
                  title={<div style={{ opacity: 0 }}>asd</div>}>
                  {staffName || ''}
                </ItemWrapper>
                <WarningPopReminder
                  title={getI18n(
                    'reviews.productreview.productReviewDetail_ReviewCard_content_deleteReply',
                  )}
                  content={getI18n(
                    'reviews.productreview.productReviewDetail_ReviewCard_content_deleteReply_content',
                  )}
                  onOkText={getI18n('general.delete')}
                  onOk={() => {
                    handleOnDelete(uuid);
                  }}>
                  <ColorLinedButton
                    //type='danger'
                    disabled={!canDelete}
                    className={css.deleteReplyBtn}>
                    {getI18n('general.delete')}
                  </ColorLinedButton>
                </WarningPopReminder>
              </div>
            ),
          },
        ]}
      />
      <Row
        containerClassName={css.replyRowContainer}
        elements={[
          { child: <div className={css.replyContentContainer}>{reply}</div> },
        ]}
      />
    </SectionContent>
  );
};

const EditingReply = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { onSubmit, onCancel } = props;
  const [text, setText] = React.useState('');

  const handleOnSubmit = () => {
    modal.error({
      title: getI18n('general.warning'),
      content: getI18n(
        'reviews.productreview.productReviewDetail_ReviewCard_content_Warning_content',
      ),
      onOkText: getI18n('general.confirm'),
      onOk: () => {
        if (onSubmit) onSubmit(text);
      },
      onCancel: () => {
        return;
      },
    });
  };

  return (
    <SectionContent hasBottomBorder>
      <ItemWrapper
        title={getI18n(
          'reviews.productreview.productReviewDetail_ReviewCard_content_replyToReview',
        )}
        rightPart={<CountWords count={(text || '').length} allCount={500} />}>
        <div className={css.editingReplyContainer}>
          <TextArea maxLength={500} value={text} onChange={setText} />
          <div className={css.editingReplyBtnsContainer}>
            <LinedButton
              onClick={onCancel}
              className={css.editingReplyCancelBtn}>
              {getI18n('general.cancel')}
            </LinedButton>
            <Button onClick={handleOnSubmit} disabled={!text} type='primary'>
              {getI18n(
                'reviews.productreview.productReviewDetail_ReviewCard_content_postreply_lineBtn',
              )}
            </Button>
          </div>
        </div>
      </ItemWrapper>
    </SectionContent>
  );
};
